import api from '../service/api.service';

export interface AddressPrediction {
  description: string;
  placeId: string;
  structuredFormatting: {
    mainText: string;
    secondaryText: string;
  };
}

interface RawAddressPrediction {
  description: string;
  place_id: string;
  structured_formatting?: {
    main_text?: string;
    secondary_text?: string;
  };
}

export interface AddressAutocompleteResponse {
  predictions: AddressPrediction[];
}

export interface ValidatedAddress {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  zip: string;
}

export interface AddressValidationResponse {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  zip: string;
}

const BASE_URL = 'v1/address';

export const getAddressSuggestionsVendor = async (input: string, token: string) => {
  const targetUrl = `${BASE_URL}/token/${token}/autocomplete?input=${input}`;
  const response = await api.get(targetUrl);

  const predictions = (response.data.predictions || []).map((p: RawAddressPrediction) => ({
    description: p.description,
    placeId: p.place_id,
    structuredFormatting: {
      mainText: p.structured_formatting?.main_text || '',
      secondaryText: p.structured_formatting?.secondary_text || '',
    },
  }));

  return { data: { predictions } };
};

export const validateAddressVendor = async (description: string, token: string, placeId?: string) => {
  const targetUrl = `${BASE_URL}/token/${token}/validate-address`;

  return await api.post<AddressValidationResponse>(targetUrl, {
    address: description,
    // eslint-disable-next-line camelcase
    place_id: placeId,
  });
};

export const getAddressSuggestions = async (input: string) => {
  const targetUrl = `${BASE_URL}/autocomplete?input=${input}`;
  const response = await api.get(targetUrl);

  const predictions = (response.data.predictions || []).map((p: RawAddressPrediction) => ({
    description: p.description,
    placeId: p.place_id,
    structuredFormatting: {
      mainText: p.structured_formatting?.main_text || '',
      secondaryText: p.structured_formatting?.secondary_text || '',
    },
  }));

  return { data: { predictions } };
};

export const validateAddress = async (description: string, placeId?: string) => {
  const targetUrl = `${BASE_URL}/validate-address`;

  return await api.post<AddressValidationResponse>(targetUrl, {
    address: description,
    // eslint-disable-next-line camelcase
    place_id: placeId,
  });
};